<template>
  <DashboardCard :border="false" :firstContent="true" class="score-width">
    <template #content>
      <div class="d-flex flex-column gap-2">
        <div class="d-flex justify-content-between align-items-center">
          <h4 class="mb-0 font-20px">{{ $t('widgets.score_extended.title1') }}</h4>
          <span class="font-20px text-success">{{ data.points_saldo }}</span>
        </div>

        <div class="d-flex justify-content-between align-items-center">
          <h4 class="mb-0 font-20px">{{ $t('widgets.score_extended.title2') }}</h4>
          <span class="font-20px text-success">{{ formatEuro(data.bonus_in_euro) }}</span>
        </div>

        <div class="d-flex justify-content-between align-items-center mt-2">
          <h4 class="mb-0 font-20px">{{ data.date || '-' }}</h4>
          <span class="font-20px text-success">{{ formatEuro(data.bonus_added_this_month) }}</span>
        </div>
      </div>
    </template>

    <template #table>
      <MDBTable borderless class="table-dashboard pt-2">
        <tbody>
          <tr>
            <td style="width:35%;">{{ $t('widgets.score_extended.balance') }}</td>
            <td style="width:15%;" class="fw-bold">{{ data.points_saldo }}</td>
            <td style="width:35%;">{{ $t('widgets.score_extended.bonus_in_euro') }}</td>
            <td style="width:15%;" class="fw-bold">{{ formatEuro(data.bonus_in_euro) }}</td>
          </tr>

          <tr>
            <td colspan="2">{{ $t('widgets.score_extended.tyres_previous_year') }}</td>
            <td colspan="2">{{ data.tyres_previous_year }}</td>
          </tr>

          <tr>
            <td colspan="2">{{ $t('widgets.score_extended.tyres_current_year') }}</td>
            <td colspan="2">{{ data.tyres_current_year }}</td>
          </tr>

          <tr>
            <td colspan="2">{{ $t('widgets.score_extended.target_this_year') }}</td>
            <td colspan="2">{{ data.target_this_year }}</td>
          </tr>

          <tr>
            <td colspan="2">{{ $t('widgets.score_extended.bonus_this_year') }}</td>
            <td colspan="2">{{ formatEuro(data.bonus_this_year) }}</td>
          </tr>

          <tr>
            <td colspan="2">{{ $t('widgets.score_extended.loyal_minimum') }}</td>
            <td colspan="2">{{ data.loyal_minimum }}</td>
          </tr>

          <tr>
            <td colspan="2">{{ $t('widgets.score_extended.bonus_multiplier') }}</td>
            <td colspan="2">{{ data.bonus_multiplier }}</td>
          </tr>
        </tbody>
      </MDBTable>
    </template>
  </DashboardCard>
</template>

<script setup>
import { computed, defineProps } from "vue";
import { useStore } from "vuex";
import { formatCurrencyEur } from "@/utils/formatCurrency";
import DashboardCard from "../User/Wholesaler/DashboardCard.vue";
import { MDBTable } from "mdb-vue-ui-kit";

const store = useStore();
const locale = computed(() => store.getters.getCurrentLocale || "en-GB");

function formatEuro(value) {
  return formatCurrencyEur(value, locale.value);
}

defineProps({
  data: {
    type: Object,
    required: true,
    default: () => ({
      points_saldo: 0,
      bonus_in_euro: 0,
      points_added_this_month: 0,
      bonus_added_this_month: 0,
      tyres_previous_year: 0,
      tyres_current_year: 0,
      target_this_year: 0,
      bonus_this_year: 0,
      loyal_minimum: 0,
      bonus_multiplier: 0,
    }),
  },
});
</script>

<style scoped lang="scss">
@import "@/styles/_variables.scss";
@import "@/styles/table_dashboard.scss";

.font-20px {
  font-size: 20px;
}
</style>
